import(/* webpackMode: "eager" */ "/app/apps/frodo/src/app/c/[catName]/[catAbbr]/[[...facets]]/error.tsx");
